import { OutputVersionType, useOutputVersionQuery } from '@atlas-frontend/sdk';
import { useEffect, useState } from 'react';

export function useOutputVersions(
  outputDataObjectId: number | undefined,
  subject: string,
  descriptionId?: string,
  valueDate?: string,
) {
  const [outputVersion, setOutputVersion] = useState<OutputVersionType>();
  const { isLoading, data } = useOutputVersionQuery(
    {
      outputDataObjectId: outputDataObjectId ?? 0,
      descriptionId: descriptionId ?? '',
      subject: subject,
      valueDate: valueDate ?? '',
    },
    {
      enabled: !!(outputDataObjectId && descriptionId && valueDate),
    },
  );
  useEffect(() => {
    const activeVersions = data?.filter((version) => version.active) ?? [];
    if (activeVersions.length === 1) {
      setOutputVersion(activeVersions[0]);
    }
  }, [data]);
  return { data, isLoading, outputVersion, setOutputVersion };
}
